import './App.css';
import React, { useState, useEffect, useRef } from 'react';
import io from 'socket.io-client';
import logo from './logo.png';

const isProd = process.env.NODE_ENV == "production"
const endpoint = "https://api.botpowered.sg/"
// const endpoint = isProd ? "" : "http://167.99.69.97:222"
if (!isProd) {
  console.log(isProd)
  localStorage.debug = '*';
}

const emojiList = ["🍩", "❤️", "⚓️", "👻", "🍪", "🍆", "☂️", "😡", "🐘"];
let socket = io(endpoint, { autoConnect: false, transports: ['websocket'],
resource: 'socket.io' });

function App() {
  const [isConnected, setIsConnected] = useState(socket.connected)

  const [isHostGameShowing, setIsHostGameShowing] = useState(false)
  const [isHostGameFailed, setIsHostGameFailed] = useState(false)
  const [isHostGameSuccess, setIsHostGameSuccess] = useState(false)
  const [hostGameResultMessage, setHostGameResultMessage] = useState("")
  const [hostGameKey, setHostGameKey] = useState("")
  const hostGameCodeRef = useRef(null)
  
  const [isHostJoinMenuShowing, setIsHostJoinMenuShowing] = useState(true)
  const [isJoinGameShowing, setIsJoinGameShowing] = useState(false)
  const [gameCodeFilled, setGameCodeFilled] = useState(false)
  const [gameCodeMaxed, setGameCodeMaxed] = useState(false)
  const [gameCodeNotFound, setGameCodeNotFound] = useState(false)
  const [gameCodeResultMessage, setGameCodeResultMessage] = useState("")

  const [player, setPlayer] = useState(-1)

  const [gameCode, setGameCode] = useState("")
  const [isPlaying, setIsPlaying] = useState(false)
  const [isGameEnded, setIsGameEnded] = useState(false)
  const [isGameStarted, setIsGameStarted] = useState(false)

  const [showRematch, setShowRematch] = useState(false)
  const [showLeave, setShowLeave] = useState(false)
  const [opponentDisconnected, setOpponentDisconnected] = useState(false)
  const [rematchAvailable, setRematchAvailable] = useState(true)
  const [rematchRequested, setRematchRequested] = useState(false)

  const [board, setBoard] = useState([
    [null, null, null],
    [null, null, null],
    [null, null, null],
  ])
  const [winningCombo, setWinningCombo] = useState([
    [false, false, false],
    [false, false, false],
    [false, false, false],
  ])
  const [turnPlayer, setTurnPlayer] = useState(-1)
  const [round, setRound] = useState(1)
  const [turnCount, setTurnCount] = useState(1)
  const [p1score, setP1score] = useState(0)
  const [p2score, setP2score] = useState(0)
  const [winner, setWinner] = useState(null)



  const joinGameCodeRef = useRef(null)
  const [session, setSession] = useState(localStorage.getItem('st_session'))

  const [isInGame, setIsInGame] = useState(false)
  const [gameData, setGameData] = useState({
  })

  const processGameData = (data) => {
    // if (player == -1) {
    //   // emit to server to get player number
    //   socket.emit('getPlayerNumber', {
    //     gameKey: data.room,
    //   }, (data) => {
    //     if (data.success) {
    //       setPlayer(data.playerNumber)
    //       console.log("updated player number to " + data.playerNumber)
    //     } else {
    //       console.log(data.message)
    //     }
    //   })
    // }

    if (data.isPlaying) {
      setIsPlaying(true)
      setIsJoinGameShowing(false)
      setIsHostGameShowing(false)
      setIsHostJoinMenuShowing(false)
    }
    if (data.ended) {
      setShowRematch(true)
      setRematchAvailable(true)
      setShowLeave(true)
    }

    console.log(data)
    setBoard(data.gameState.board)
    setTurnPlayer(data.turnPlayer)
    setRound(data.round)
    setTurnCount(data.turnCount)
    setP1score(data.p1score)
    setP2score(data.p2score)
    setWinner(data.winner)
    setIsGameStarted(data.started)
    setIsGameEnded(data.ended)
    setGameCode(data.room)
    setWinningCombo(data.gameState.winningCombo)
  }

  socket.on('new-session', (payload) => {
    console.log("setting new session token (" + payload.name.toString() + ") to " + payload.value.toString())
    localStorage.setItem(payload.name, payload.value)
    setSession(payload.value)
  })

  socket.on('updatePlayerNumber', (payload) => {
    console.log("updated player number to " + payload.playerNumber)
    setPlayer(payload.playerNumber)
  })

  socket.on('opponentDisconnected', (payload) => {
    console.log("opponent disconnected")
    if (payload.playerNumber == player) {
      setOpponentDisconnected(true)
    }
  })

  socket.on('opponentConnected', (payload) => {
    console.log("opponent connected")
    setOpponentDisconnected(false)
  })

  socket.on('connect', () => {
    setIsConnected(true);
  })


  socket.on('disconnect', () => {
    setIsConnected(false);
  });

  

  socket.on('gameState', (game) => {
    // console.log("gameState: " + JSON.stringify(game))
    processGameData(game)
  });

  socket.on('restartGame', () => {
    setRematchAvailable(true)
    setRematchRequested(false)
    setShowRematch(false)
  })

  socket.on('rematchRequest', () => {
    setRematchRequested(true)
  })

  const requestRematch = () => {
    socket.emit('rematchRequest', {
      gameKey: gameCode,
    }, (data) => {
      // if (data.success) {
      //   setRematchRequested(true)
      // } else {
      //   setRematchRequested(false)
      //   // setRematchAvailable(true)
      // }
    }
    )
  }

  const leaveGame = () => {
    socket.emit('leaveGame', {
      gameKey: gameCode,
    }, (data) => {
      console.log(data)
    })
    // reset to main menu
    setIsHostJoinMenuShowing(true)
    setIsJoinGameShowing(false)
    setIsHostGameShowing(false)
    setIsInGame(false)
    setIsPlaying(false)
    setRematchAvailable(false)
    setRematchRequested(false)
    setShowRematch(false)
    setOpponentDisconnected(false)
    setGameCodeNotFound(false)
    setGameCodeResultMessage("")
    setGameCodeMaxed(false)
  }

  const handleHostGame = () => {
    socket.emit('hostGame', (response) => {
      setHostGameResultMessage(response.message)
      if(response.success) {
        setIsHostGameSuccess(true)
        setHostGameKey(response.gameKey)
        setIsHostJoinMenuShowing(false)
        setIsHostGameShowing(true)
        // hostGameCodeRef.current.value = response.gameKey
      } else {
        setIsHostGameFailed(true)
      }
    }) 
  }

  const joinGame = () => {
    socket.emit('joinGame', {gameKey: joinGameCodeRef.current.value}, (response) => {
      console.log(response)
      setGameCodeNotFound(!response.success)
      setGameCodeResultMessage(response.message)
      if (response.success) {
        setIsHostJoinMenuShowing(false)
        setIsJoinGameShowing(true)
      }
    })
  }

  useEffect(() => {
    // refreshSession when game starts
    if (isPlaying) {
      refreshSession()
    }
  }, [isPlaying])


  const refreshGameCodeLength = () => {
    let len = 0;
    if (joinGameCodeRef.current == null) {
      len = 0
    } else {
      len = joinGameCodeRef.current.value.length
    }
    if (len > 0) {
      setGameCodeFilled(true)
    } else {
      setGameCodeFilled(false)
    }

    if (len >= 8) {
      // attempt to join game
      let response = joinGame()
      setGameCodeMaxed(true)
    } else {
      setGameCodeMaxed(false)
    }
  }

  // if (!isProd) {
  //   socket.onAny((event, ...args) => {
  //     console.log(event, args);
  //   });
  // }

  const refreshSession = () => {
    try {
      socket.disconnect()
    } catch (e) {
      console.log("error disconnecting socket")
    }
      const sessionId = localStorage.getItem('st_session')
      const requestNewSessionId = (sessionId === null)
      socket.auth = { requireNewSession: requestNewSessionId, st_session: sessionId }
      socket.connect();
  }
  useEffect(() => {
    refreshSession()
  }, [])

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        { !isProd &&
        <div className="socketInfo" style={{
          fontSize: "0.4em"
        }}>
        <p>
          { isConnected ? "socket connected" : "socket disconnected" }
        </p>

        <p>
          { session ? "session token: " + session : "no session token" }
        </p>
        {
          isHostGameFailed &&
          <h3 style={{ color: 'red' }}>{hostGameResultMessage}</h3>
        }
        </div>
        }
        { isHostJoinMenuShowing && 
        <div>
          <h5>Welcome to Socket Tic Tac Toe</h5>
        <div className="hostJoinMenu">
          <button onClick={() => {
            handleHostGame()
          }}>
            Host Game
          </button>

          <button onClick={() => {
            setIsHostJoinMenuShowing(false)
            setIsJoinGameShowing(true)
          }}>
            Join Game
          </button>

          {/* <button onClick={() => {
            // socket.emit('init', 'test')
          }}>
            test session
          </button> */}
        </div>
        </div>
        }
        { isJoinGameShowing &&
        <div className="joinGameWrapper"
        style={{
          width: "10em",
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <div style={{ display:'flex', flexDirection: 'column'}}>
          <p style={{ marginBottom: 0 }}>Join a Game</p>
          {/* { gameCodeNotFound &&  */}
            <p style={{ 
              fontSize: '0.7em', 
              marginTop: '0.5em',
              color: (gameCodeNotFound ? 'red' : 'green')
              }}>{gameCodeResultMessage}</p>
          {/* } */}
          </div>
          <div className="joinCodeText" style={{
            width: "100%",
            display: 'flex',
            flexDirection: 'row',
          }}>
            <input disabled ref={joinGameCodeRef} style={{ 
              width: "100%",
              textAlign: 'center',
              fontSize: '1.5em',
            }}>
            </input>
            { (gameCodeFilled) &&
            <button onClick={() => { 
              joinGameCodeRef.current.value = ""
              refreshGameCodeLength()
              setGameCodeNotFound(false)
              setGameCodeResultMessage("")
            }}>X</button>
            }
          </div>
          
          <div 
          className="joinGameSelectors"
          style={{
            width: "100%"
          }}>
          { emojiList.map((emoji, index) => {
              return <div
              style={{
                display: 'inline'
              }}
              key={index}><button 
              style={{
                width: "33%",
                fontSize: '1em',
                paddingTop: '1em',
                paddingBottom: '1em',
                WebkitAppearance: 'none',
              }} 
              disabled={gameCodeMaxed}
              onClick={() => {
                joinGameCodeRef.current.value += emoji
                refreshGameCodeLength()
              }}>{emoji}</button>{(index+1) % 3 === 0 && <br/> }</div>
            })}
          </div>
        </div>
        }

        { isHostGameShowing &&
        <div className="hostGameWrapper"
        style={{
          width: "10em",
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <div style={{ display:'flex', flexDirection: 'column'}}>
          <p style={{ marginBottom: 0 }}>Host a Game</p>
          <h5 style={{
            margin: '1em 0 0.5em 0',
            fontSize: '0.6em',
          }}>Game Code</h5>
          </div>
          <div className="joinCodeText" style={{
            width: "100%",
            display: 'flex',
            flexDirection: 'row',
          }}>
            <input disabled ref={hostGameCodeRef} value={hostGameKey} style={{ 
              width: "100%",
              textAlign: 'center',
              fontSize: '2em',
            }}>
            </input>
          </div>
          <p style={{ fontSize: '0.5em'}}>Waiting for opponent..</p>
        </div>
        }


        { isPlaying &&
        <div className="gameWrapper">
          <div className="gameInfo">
            <p>
              { gameCode }
            </p>
            <p>
              { isGameEnded ? 
              "Game Over" : (player == turnPlayer ? "Your Turn" : "Opponent's Turn") 
              }
            </p>
            <p className={(winner == player || winner == 3 ? "win" : "lose")}>
              { isGameEnded && !rematchRequested ?
                (winner == player ? "You won!"
                : winner == 3 ? "Tie!" : "You lost!")
                :
                null
              }
            </p>
            { isGameEnded &&
            <div style={{
              marginBottom: '1em',
            }}>
            <p style={{
              display: 'inline',
              fontWeight: (player == 1 ? 'bold' : 'normal'),
              textDecoration: (player == 1 ? 'underline' : 'none'),
            }}>{ p1score }</p>
            <p style={{
              display: 'inline'
            }}> - </p>
            <p style={{
              display: 'inline',
              fontWeight: (player == 2 ? 'bold' : 'normal'),
              textDecoration: (player == 2 ? 'underline' : 'none'),
            }}>{ p2score }</p>
            </div>
            }

            { 
              (rematchRequested && !opponentDisconnected) &&
              <h5 style={{
                color: 'green',
              }}>
                Rematch Requested
              </h5>
            }


            { opponentDisconnected &&
            <p className="lose">
              Opponent Disconnected</p>}
            
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
            }}>
            { showRematch &&
              <button onClick={() => {
                setRematchAvailable(false)
                requestRematch()
              }}
              disabled={opponentDisconnected || !rematchAvailable}
              >
                Rematch
              </button>
            }


            { (isPlaying) &&
            <button onClick={() => {
              leaveGame()
            }}>
              Leave Game
            </button>
            }

            </div>



            
          </div>
          <div className="gameBoard" key={(gameCode + player)}>
            {
              board.map((row, rowIndex) => {
                return <div key={rowIndex + gameCode + player} className="gameRow">
                  {
                    row.map((cell, cellIndex) => {
                      return <div key={cellIndex} className={"gameCell " + 
                      (cell == " " ? "emptyGameCell " : "playedGameCell ") + 
                      (winningCombo[rowIndex][cellIndex] ? (winner == player ? "winningCell " : "losingCell") : "")
                    } onClick={() => { 
                        if (player == turnPlayer) {
                          console.log("playing turn", gameCode, player, rowIndex, cellIndex)
                          socket.emit('playTurn', {
                            gameCode: gameCode,
                            player: player,
                            row: rowIndex,
                            col: cellIndex,
                          }, (data) => {
                            if (data.status == 'error') {
                              // alert(data.message)
                              // refresh page
                              if (data.message == "invalid session") {
                                console.log('invalid session, reloading')
                                window.location.reload()
                              } else {
                                alert(data.message)
                              }
                            }
                          })
                        }
                      }}>
                        { cell }
                      </div>
                    })
                  }
                </div>
              })
            }
            </div>
        </div>
        }
      </header>
    </div>
  );
}

export default App;
